import "./App.css";
import CaseComponent from "./components/case/CaseComponent";
import CaseTemplateComponent from "components/case/CaseTemplateComponent";
import CreateScreen from "pages/createScreen/createScreen";
import News from "pages/smartNews/News";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<News />} />
          <Route path="/create-video" element={<CaseComponent />} />
          <Route path="/create-video-template" element={<CreateScreen />} />
          <Route path="/video-template" element={<CaseTemplateComponent />} />

          {/* <Route
            path="/video-template-editor"
            element={<CaseComponent />}
          ></Route> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
